import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TableListeService } from 'src/app/service/tableListe.service';

@Component({
  selector: 'app-dialogue-relation',
  templateUrl: './dialogue-relation.component.html',
  styleUrls: ['./dialogue-relation.component.scss']
})
export class DialogueRelationComponent implements OnInit {

  public tmp = {
    typeHasRelation: false
  };
  public types;
  public relationList;
  public list;
  public dataElement;

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data,
    private tableListeService: TableListeService
  ) {
    this.types = data.types;
    this.relationList = data.element;
    this.list = data.list;
    this.dataElement = data.dataElement;
  }

  closeDialogue() {
    this.dialogRef.close();
  }

  showThisThesaurus(thesaurus_id) {
    // let indexElement = -1;
    // let indexSearchElement = -1;
    // let element = null;
    // for (let i = 0; i < this.list.length; i++) {
    //   if (this.list[i].thesaurus_id === this.dataElement.thesaurus_id) {
    //     indexElement = i;
    //     break;
    //   }
    // }
    // for (let i = 0; i < this.list.length; i++) {
    //   if (this.list[i].thesaurus_id === IdThes) {
    //     indexSearchElement = i;
    //     element = this.list[i];
    //     break;
    //   }
    // }
    // this.dialogRef.close({ indexElement, indexSearchElement, element });

    // check if list contain the thesaurus
    let contain = false;
    let index = -1;
    let currentIndex = -1;
    this.list.map((el, i) => {
      if (el.thesaurus_id === thesaurus_id) {
        contain = true;
        index = i;
      }
      
      if (el.thesaurus_id === this.dataElement.thesaurus_id) {
        currentIndex = i;
      }
    })

    // if not contain, get the thesaurus
    if (!contain) {
      this.tableListeService.getThesaurusById(thesaurus_id).toPromise().then((thesaurus: any) => {
        thesaurus.type = thesaurus.type.param_description;
        thesaurus.etat = thesaurus.etat.param_description;
        thesaurus.theme = thesaurus.theme.param_description;
        thesaurus.num_relations = isNaN(thesaurus.num_relations) ? false : thesaurus.num_relations;
        this.dialogRef.close({contain, data: { thesaurus, currentIndex }})
      })
    } else {
      this.dialogRef.close({contain, data: { index, currentIndex }})
    }
  }

  typeHasRelationF(IdType: number) {
    this.tmp.typeHasRelation = false;
    this.relationList.forEach(element => {
      if (element.type.param_id === IdType) {
        this.tmp.typeHasRelation = true;
      }
    });
    return this.tmp.typeHasRelation;
  }

  ngOnInit() { }
}
